interface Props {
  text?: string;
}

export const Loading = ({ text = 'Loading...' }: Props) => {
  return <div className="text-sm text-foreground py-2">{text}</div>;
};
